<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    mounted() {
       
    },
    watch: {
        model(value) {
            console
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                if (this.field.key == 'accountInfo.nomineeRelationship1Id') {
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.relationWithPrinciple',
                        value: selectedItem.value,
                    })
                    this.$store.commit('updateField', {
                        key: 'accountInfo.nomineeRelationship1',
                        value: selectedItem.title,
                    })
                    // console.log("bank code:" , this.$store.state.registration.form.asaanAccInfo.bank)
                    // console.log("bankname:" , this.$store.state.registration.form.accountInfo.bankName)
                }
            }
        },
    }, // End of Component > watch
}
</script>
